function DevBanner() {
  return (
    <div className="bg-crm-dev text-white text-center text-xs py-1 font-semibold">
      DEV ENVIRONMENT
    </div>
  )
}

export default DevBanner
